'use client'

import { CloudflarePicture } from '@/ui/media/cloudflare-picture/CloudflarePicture.client'
import { gql } from '@gql-generated/gql'
import type { ProductNorms_NormFragment } from '@gql-generated/graphql'
import { PRODUCT_IMAGE_SIZE_THUMBNAIL } from '../../services/product.constants'

gql(/* GraphQL */ `
  fragment ProductNorms_Norm on Norm {
    id
    name
    image
  }
`)

export type ProductNormsProps = {
  norms: ProductNorms_NormFragment[]
}

export function ProductNorms({ norms }: ProductNormsProps): React.ReactElement | null {
  const displayList = norms.filter((norm) => !!norm.image)

  if (!displayList.length) return null

  return (
    <div className="flex flex-wrap items-center gap-2" data-testid="product-norms">
      {displayList.map((norm) => (
        <CloudflarePicture
          key={norm.id ?? norm.name}
          src={norm.image!}
          alt={norm.name}
          height={PRODUCT_IMAGE_SIZE_THUMBNAIL}
          quality={100}
          mode="contain"
          isInternalPicture // From the SID / M2
          className="max-h-10 w-auto"
        />
      ))}
    </div>
  )
}
